export class ActivityMonitor {
    lastActivity: number;

    constructor() {
        document.addEventListener('mousemove', this.boundActivityMonitor.bind(this));
        document.addEventListener('scroll', this.boundActivityMonitor.bind(this));
        document.addEventListener('keypress', this.boundActivityMonitor.bind(this));
        this.lastActivity = new Date().getTime();
    }

    boundActivityMonitor() {
        this.lastActivity = new Date().getTime();
    }
}